module.exports = __webpack_public_path__ + "static/media/ptm_profil.fe5ade22.png";